"use client"
import "./static-timer.css"

// Helper function to get icon based on text
const getIconFromText = (text) => {
  if (!text) return null

  const lowerText = text.toLowerCase()

  if (lowerText.includes("individual") || lowerText.includes("individueel")) return "👤"
  if (lowerText.includes("group") || lowerText.includes("groep")) return "👥"
  if (lowerText.includes("pair") || lowerText.includes("tweetallen")) return "👫"
  if (lowerText.includes("team")) return "🧑‍🤝‍🧑"
  if (lowerText.includes("discuss") || lowerText.includes("bespreek")) return "💬"
  if (lowerText.includes("brain") || lowerText.includes("denk")) return "🧠"
  if (lowerText.includes("write") || lowerText.includes("schrijf")) return "✍️"
  if (lowerText.includes("read") || lowerText.includes("lees")) return "📖"
  if (lowerText.includes("watch") || lowerText.includes("kijk")) return "👀"
  if (lowerText.includes("listen") || lowerText.includes("luister")) return "👂"
  if (lowerText.includes("share") || lowerText.includes("deel")) return "🔄"
  if (lowerText.includes("create") || lowerText.includes("maak")) return "🛠️"
  if (lowerText.includes("reflect") || lowerText.includes("reflecteer")) return "🤔"
  if (lowerText.includes("present") || lowerText.includes("presenteer")) return "🎤"

  return null
}

const TagPill = ({ text, icon, backgroundColor = "#4f46e5", textColor = "white" }) => {
  // Use provided icon or try to determine one based on text
  const displayIcon = icon || getIconFromText(text)

  return (
    <div
      className="tag-pill"
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
      }}
    >
      {displayIcon && <span className="tag-pill-icon">{displayIcon}</span>}
      <span>{text}</span>
    </div>
  )
}

export default TagPill
